import styles from './SearchTeaserLoader.module.scss';

const SearchTeaserLoader = () => (
  <div className={styles.root}>
    <div className={styles.image} />
    <div>
      <div className={styles.title} />
      <div className={styles.description} />
    </div>
  </div>
);

export default SearchTeaserLoader;
